module.exports = __webpack_public_path__ + "static/media/website-vannya-me.3e6ff094.png";